<div class="container">
    <mat-dialog-title class="title-block">
        <h2>Edit DATA SET</h2>
        <app-close-x-icon (click)="onClose()"></app-close-x-icon>
    </mat-dialog-title>

    <mat-dialog-content class="content-block">

        <div class="user-container">
            <div class="user-block">
                <span id="user-label">USER:</span>
    
                <span id="user-name">
                    {{selectedUser.first_name}} {{selectedUser.last_name}}
                </span>
            </div>
        </div>

        <div class="available-data">
            <div class="available-data-top-row">
                <h3 class="header">AVAILABLE DATA</h3>
                <span class="select-all" (click)="selectAllProperties()">Select all</span>
            </div>

            <div class="properties-selection-group">
                <section [ngClass]="{'selected-checkbox' : !property.isRestricted}"
                    *ngFor="let property of selectableProperties" class="property-selection">
                    <mat-checkbox [checked]="!property.isRestricted"
                        (ngModelChange)="property.isRestricted = !property.isRestricted"
                        (change)="setPropertyRestriction(property)">{{property.name}}</mat-checkbox>
                </section>
            </div>
        </div>

    </mat-dialog-content>

    <mat-dialog-actions class="action-block">
        <button class="create-data-set-btn" mat-button (click)="updateDataSet()">UPDATE DATA SET</button>
        <button class="cancel-btn" mat-button (click)="onClose()">CANCEL</button>
    </mat-dialog-actions>
</div>